import React from "react";
import Header from "../Header";
import ContatoFooter from "../ContatoFooter";
import Footer from "../Footer";
import styles from "./Layout.module.css";

const Layout = ({ children }) => {
  return (
    <>
      {/* Link de acessibilidade */}
      <a href="#main-content" className={styles.skipLink}>
        Pular para o conteúdo
      </a>

      <Header />

      {/* Área principal recebe ID pra skipLink */}
      <main id="main-content" className={styles.main}>
        {children}
      </main>

      <ContatoFooter />

      {/* <Footer /> */}
    </>
  );
};

export default React.memo(Layout);
